// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import Modal from 'react-modal'
import { useBooleanToggle } from 'hooks'
import Wrapper from './Wrapper'
import iconSrc from 'images/interference-analysis-afs-parameters.png'

const idRoot = 'user-analysis-statuses'

const UserAnalysisStatuses = () => {
  const [isOpen, toggleOpen] = useBooleanToggle(false)

  return (
    <>
      <a
        className={'text-white pointer'}
        id={`${idRoot}-trigger`}
        onClick={toggleOpen}>
        <img
          className={'bg-white'}
          style={{
            borderRadius: '50%',
            overflow: 'hidden',
          }}
          src={iconSrc} />
        {`Analysis Status`}
      </a>
      {
        isOpen &&
        <Modal
          className={'modal-content-default modal-content-flex padding-0'}
          contentLabel={idRoot}
          isOpen={true}
          onRequestClose={toggleOpen}
          overlayClassName={'modal-overlay-default modal-overlay-flex'}>
          <Wrapper
            closeModal={toggleOpen}
            idRoot={idRoot} />
        </Modal>
      }
    </>
  )
}

export default UserAnalysisStatuses
